
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programs/odc-workshops",
      function () {
        return require("private-next-pages/programs/odc-workshops.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programs/odc-workshops"])
      });
    }
  